<template>
  <div class="p-2">
    <div class="card">
      <div class="card-body">
        
        <div class="data" v-if="error == ''">
          <div class="">
            <h4>Endpoints</h4>
            <hr>
            <div class="line-input">
              <div class="form-group w90">
                <label for="get_products">Obtener Productos</label>
                <input v-model="end_points.get_products" type="text" name="get_products" id="get_products" class="form-control">
              </div>
              <button :disabled="loading" @click="runProducts" class="btn main-bg">Ejecutar</button>
            </div>

            <div class="line-input">
              <div class="form-group w90">
                <label for="get_categories">Obtener Categorias</label>
                <input v-model="end_points.get_categories" type="text" name="get_categories" id="get_categories" class="form-control">
              </div>
              <button :disabled="loading" @click="runCategories" class="btn main-bg">Ejecutar</button>
            </div>
            
          </div>

          <div class="mt-3">
            <h4>Campos producto</h4>
            <hr>
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="id">Código</label>
                  <input v-model="fields.id" type="text" name="id" id="id" class="form-control">
                </div>
                <div class="form-group">
                  <label for="name">Nombre</label>
                  <input v-model="fields.name" type="text" name="name" id="name" class="form-control">
                </div>
                <div class="form-group">
                  <label for="category">Categoria</label>
                  <input v-model="fields.category_id" type="text" name="category" id="category" class="form-control">
                </div>
                
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="photo">Foto</label>
                  <input v-model="fields.photo" type="text" name="photo" id="photo" class="form-control">
                </div>
                <div class="form-group">
                  <label for="description">Descripción</label>
                  <input v-model="fields.description" type="text" name="description" id="description" class="form-control">
                </div>
                <div class="form-group">
                  <label for="offer">En oferta</label>
                  <input v-model="fields.offer" type="text" name="offer" id="offer" class="form-control">
                </div>
              </div>
              <div class="col-sm-4">
                
                <div class="form-group">
                  <label for="stock">Stock</label>
                  <input v-model="fields.stock" type="text" name="stock" id="stock" class="form-control">
                </div>
                <div class="form-group">
                  <label for="price">Precio</label>
                  <input v-model="fields.price" type="text" name="price" id="price" class="form-control">
                </div>
                <div class="form-group">
                  <label for="retail_price">Precio venta</label>
                  <input v-model="fields.retail_price" type="text" name="retail_price" id="retail_price" class="form-control">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-7 text-left">
                <div class="form-group">
                  <label for="photo_prepend">Ruta base fotos</label>
                  <input v-model="fields.photo_prepend" type="text" name="photo_prepend" id="photo_prepend" class="form-control">
                </div>
              </div>
              <div class="col-sm-5 text-right save-changes">
                <button :disabled="loading" @click="save" class="btn btn-primary"><i class="fa fa-save"></i> GUARDAR CAMBIOS</button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-danger">
          {{ error }}
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { UtilsService } from '../../services/UtilsService'
export default {
  name: 'CompanyAPI',
  props: ['companyId'],
  data: function(){
    return {
      end_points: {
        get_products: '',
        get_categories: ''
      },
      fields: {
        id: '',
        name: '',
        price: '',
        photo: '',
        description: '',
        category_id: '',
        brand: '',
        stock: '',
        retail_price: '',
        offer: '',
        photo_prepend: ''
      },
      convertion_rate: '',
      loading: false,
      utilsService: new UtilsService(),
      error: '',
    }
  },
  methods: {
    async save(){
      this.loading = true;
      const res = await this.utilsService.saveCompanyAPIInfo(this.companyId, {
        end_points: this.end_points,
        fields: this.fields
      });
      if(res.ok){
        this.$helpers.message('Bien', 'Datos actualizados');
      }else{
        this.$helpers.message('Error', res.message ,'error');
      }
      this.loading = false;
    },
    async runCategories(){

    },
    async runProducts(){
      this.loading = true;
      const res = await this.utilsService.companyRunAPIProducts(this.companyId);
      if(res.ok){
        this.$helpers.message('Bien', `Proceso exitoso! \n ${res.data.productsCount} productos importados`);
      }else{
        this.$helpers.message('Error', res.message ,'error');
      }
      this.loading = false;
    },
    async getAPIInfo(){
      this.loading = true;
      const res = await this.utilsService.getCompanyAPIInfo(this.companyId);
      if(res.ok){
        if(res.data.end_points){
          this.end_points = res.data.end_points;
        }
        if(res.data.fields){
          this.fields = res.data.fields;
        }
      }else{
        this.error = res.message;
      }
      this.loading = false;
    }
  },
  beforeMount(){
    this.getAPIInfo();
  }
}
</script>
<style scoped>
h4{
  margin-bottom: 0;
  margin-top: 0;
}
.line-input{
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}
.w90{
  width: 90%;
}
.save-changes{
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}
</style>